import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';


import CompanyUser from "api/CompanyUser";

import CompanyUserModel from 'models/CompanyUser';
import { connect } from "react-redux";
import {Add as CompanyUserAddView} from 'views/companyuser/Add';
import {
  MESSAGE_SUCCES,
	MESSAGE_INFO,
	SHOW_MAINMENU
} from "actions/types";
import {showLoader,hideLoader} from "actions/types";

class CompanyUserAddController extends React.Component {
	constructor(props) {
		super(props);

		this.state = {error: null,isLoaded: false,user: new CompanyUserModel(), validation: false};
		
	}

	async componentDidMount() {
		const {companyid, userid, dispatch} = this.props;
		if(userid) {
				let mobileButton = (
					<>
					<div className="d-flex">
						<a href="#" onClick={this.mobileBackButtonHandler} className="back btn-circle">
							<svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24">
								<path d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z"></path>
							</svg>
						</a>
						<a href="#" onClick={this.mobileButtonClickHandler} className="save btn-circle">
							<svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24">
								<path d="M12,10a4,4,0,1,0,4,4A4,4,0,0,0,12,10Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,16Z"/><path d="M22.536,4.122,19.878,1.464A4.966,4.966,0,0,0,16.343,0H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V7.657A4.966,4.966,0,0,0,22.536,4.122ZM17,2.08V3a3,3,0,0,1-3,3H10A3,3,0,0,1,7,3V2h9.343A2.953,2.953,0,0,1,17,2.08ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2V3a5.006,5.006,0,0,0,5,5h4a4.991,4.991,0,0,0,4.962-4.624l2.16,2.16A3.02,3.02,0,0,1,22,7.657Z"/>
							</svg>
						</a>
					</div>
					</>
);
				
				dispatch(showLoader(true, mobileButton));
			var {user} = this.state;
			var userData = await CompanyUser.getUserById(companyid, userid).then((response) =>   {
				return response.data;
			});
			user.addData(userData);
			this.setState({user: user});
			dispatch(hideLoader());
		}
	}

	mobileBackButtonHandler= (event) => {
		const {navigate, companyid } = this.props;
		navigate('/company/'+companyid+'/user');
	}
	
	mobileButtonClickHandler= (event) => {
		event.preventDefault();
		const {user} = this.state;
		this.onSaveHandler(user);
	}
	
	/*
	 * on cancel go back to overview company users
	 */
	onCancel = () => {
		const {navigate, companyid } = this.props;
		navigate('/company/'+companyid+'/user');
		//this.props.navigate('login');
	}
		
	onSaveHandler = (userData, photoHolder) => {
		const { dispatch, navigate, companyid } = this.props;
		try {	
			dispatch(showLoader());
			this.setState({isLoaded: true});
			var companyPromise;
			if( userData.id == 0 ) {
				companyPromise = CompanyUser.create(companyid, userData.getData());
			} else {
				companyPromise = CompanyUser.update(companyid, userData.getData());
			}
				
			companyPromise.then((response) =>   {
					var user = new CompanyUserModel();
					user.addData(response.data.data.data);
					this.setState({isLoaded: false, user: user});
					dispatch({ type: MESSAGE_SUCCES, "message": "De nieuwe medewerker is succesvol opgeslagen", "header": "Medewerker info" });
					navigate('/company/'+companyid+'/user');
					dispatch(hideLoader());
			}).catch((err) => {
				if(err.response.status == 422) {
					this.setState({validation: err.response.data.data, user: userData});
					dispatch({ type: MESSAGE_INFO, "message": "In het formulier zijn validatie fouten gevonden!", "header": "Validatie fouten" });
				}
				dispatch(hideLoader());
			});
	
				
		} catch(error) {
			console.log( " error ", error );
		}				
		/*		
		this.productApi.addProduct(productData)
			.then((response) =>   {
				
			console.log("addproducts", response.data);
		})
		.catch((err) => {
			if(err.response.status == 422) {
				this.setState({validation: err.response.data.data});
				dispatch({ type: MESSAGE_INFO, "message": "In het formulier zijn validatie fouten gevonden!", "header": "Validatie fouten" });
			}
		});		
		*/
	}

	render() {
		const {categories,user, validation } = this.state;
	return <CompanyUserAddView initData={user} onSave={this.onSaveHandler} initCategories={categories} validation={validation} onCancel={this.onCancel}/>;
	}

}

const CompanyUserAddInit = (props) => {
    let { companyid,id } = useParams();
	let navigate = useNavigate();

	return (<CompanyUserAddController {...props} companyid={companyid} userid={id} navigate={navigate}/>)
}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn
  };
}

//export default (ProductAdd);

export default connect(mapStateToProps)(CompanyUserAddInit);